<template>
    <input type="number" min="1" :value="value" @keypress="handleInput" @input="update">
</template>

<script>
    /**
     * Standard input field which allow only numbers and period
     */
    /* eslint-disable */
    export default {
        name: 'BaseInputWholeNumber',
        props: ['value'],
        methods: {
            handleInput($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if (keyCode < 48 || keyCode > 57) { // 46 is dot
                    $event.preventDefault();
                }
            },
            update(e) {
                this.$emit('input', e.target.value);
            },
        },
    };
</script>
